import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgxAimViewGroup } from './ngx-aim-view-group.class';
import { RouterOutlet } from '@angular/router';
import { StationHoursPipe, StationImagePipe } from '../../../pipes';

@Component({
  selector: 'ngx-aim-view-group',
  standalone: true,
  imports: [RouterOutlet, StationImagePipe, StationHoursPipe],
  templateUrl: './ngx-aim-view-group.component.html',
  styleUrl: './ngx-aim-view-group.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxAimViewGroupComponent extends NgxAimViewGroup implements OnInit {
  @Input() set skipDurationSelect(skip: boolean) {
    this.stationsService.skipDurationSelect = skip;
  }

  @Input() set addButtonForAllDay(add: boolean) {
    this.stationsService.addButtonForAllDay = add;
  }

  @Input() set stationHasTerms(hasTerms: boolean) {
    this.stationsService.stationHasTerms = hasTerms;
  }

  @Input() set showAddOns(showAddOns: boolean) {
    this.stationsService.showAddOns = showAddOns;
  }

  ngOnInit() {
    this.init();
  }
}
